// src/api/graphql/mutations/sellerRegisterMutation.ts

import { gql } from "@apollo/client";

export const SELLER_REGISTER_MUTATION = gql`
  mutation SellerRegister(
    $email: String!
    $password: String!
    $shopTitle: String!
    $contactNumber: String!
    $description: String!
    $billingAddress: BillingAddressInput!
  ) {
    sellerRegister(
      email: $email
      password: $password
      shopTitle: $shopTitle
      contactNumber: $contactNumber
      description: $description
      billingAddress: $billingAddress
    ) {
      success
      seller {
        id
        email
        shop_title
        contact_number
        description
        shop_url
      }
      token
      message
    }
  }
`;

export interface BillingAddressInput {
  firstname: string;
  lastname: string;
  street: string[];
  city: string;
  postcode: string;
  countryId: string;
  region: {
    region: string;
    regionId?: number;
    regionCode?: string;
  };
  vatId?: string;
}
